import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { BackIcon, GamifyIcon } from '../../components/GamifyIcon';

export default function ProfileNoUserDisplay({ isDeleted }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/people');
  };

  return (
    <>
      <Box
        style={{
          height: '100vh',
          width: '100vw',
          paddingTop: '90px',
          paddingLeft: '60px',
          paddingRight: '60px',
          margin: 0,
          //   background:
          //     'radial-gradient(circle at 50% 80%, #FFD773 0%, #FF8630 50%, #FF6A00 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            width: 200,
            height: '100%',
            paddingTop: 34,
          }}
        >
          <Button
            className={'profile-about-page-back-button'}
            onClick={(e) => handleBack(e)}
            disableRipple={true}
          >
            <BackIcon></BackIcon>
            <Typography
              style={{
                color: '#0B0B0C',
                fontWeight: 600,
                fontSize: 16,
                marginLeft: 16,
              }}
            >
              {'Back to people'}
            </Typography>
          </Button>
        </Box>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
          }}
        >
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#FF6A0026',
              height: 70,
              width: 70,
              borderRadius: 1000,
              marginBottom: 16,
            }}
          >
            <GamifyIcon icon={'noResults'} color={'#FF6A00'}></GamifyIcon>
          </Box>
          <Typography style={{ fontSize: '18px' }}>
            {isDeleted
              ? 'This user has been deleted,'
              : 'There is no user with this ID,'}
          </Typography>
          <Typography style={{ fontSize: '18px' }}>
            {'please go back to Users'}
          </Typography>
        </Box>
        <Box
          style={{
            width: 200,
            height: '100%',
            paddingTop: 34,
          }}
        >
          <Typography style={{ color: 'transparent' }}>.</Typography>
        </Box>
      </Box>
    </>
  );
}
